import React from "react";
import { phoneMask } from "../../../utils/normalize";
import { isMobile } from "../../../utils/validation";
import { Button } from "../../../components/Button";
import { Text } from "../../../components/Text";

const Confirmation = ({ values, onSubmit, loading, previousPage }) => {
  const { name, email, phone, licensePlate, brand, model } = values;

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <h4 style={{ margin: 0 }}>
          <b>Confirmação de Dados</b>
        </h4>
        <p style={{ fontSize: "small" }}>
          {window.location.href.includes("newvehicle")
            ? "Confirme os seus dados para criação do veículo"
            : "Confirme os seus dados para criação da conta"}
        </p>
      </div>
      <div className="signup-confirmation" style={{ width: "100%" }}>
        {window.location.href.includes("signup") && (
          <div
            style={{
              borderTop: "1px solid #d8d8d8",
              borderBottom: "1px solid #d8d8d8",
            }}
          >
            <span style={{ fontSize: "0.875rem" }}>
              <b>Nome:</b> {name}
            </span>
            <span style={{ fontSize: "0.875rem" }}>
              <b>E-mail:</b> {email}
            </span>
            <span style={{ fontSize: "0.875rem" }}>
              <b>Telefone: </b> {phoneMask(phone)}
            </span>
          </div>
        )}
        <div
          style={
            window.location.href.includes("newvehicle")
              ? {
                  borderTop: "1px solid #d8d8d8",
                  borderBottom: "1px solid #d8d8d8",
                }
              : { borderBottom: "1px solid #d8d8d8" }
          }
        >
          <span style={{ fontSize: "0.875rem" }}>
            <b>Placa: </b> {licensePlate}{" "}
          </span>
          <span style={{ fontSize: "0.875rem" }}>
            <b>Modelo: </b> {model?.label}
          </span>
          <span style={{ fontSize: "0.875rem" }}>
            <b>Marca: </b> {brand?.label}
          </span>
        </div>
      </div>
      <br />
      {isMobile() ? (
        <div className="signup-form-div-buttons">
          <Button color="red400" onClick={previousPage} disabled={loading}>
            Voltar
          </Button>
          <Button color="green450" disabled={loading} onClick={onSubmit}>
            <span className={loading ? "fa fa-spinner fa-pulse fa-1x" : ""} />
            Concluir
          </Button>
        </div>
      ) : (
        <div className="signup-form-div-buttons" style={{ width: "100%" }}>
          <Button
            color="red400"
            onClick={previousPage}
            disabled={loading}
            style={
              window.location.href.includes("signup")
                ? {}
                : { marginRight: "10px" }
            }
          >
            Voltar
          </Button>
          <Button color="green450" onClick={onSubmit} disabled={loading}>
            <span
              className={loading ? "fa fa-spinner fa-pulse fa-1x" : ""}
              style={{ marginRight: 5 }}
            />
            Concluir
          </Button>
        </div>
      )}
    </>
  );
};

export default Confirmation;
